(function () {
  const root = document.getElementById('cfs-root');
  if (!root) return;

  const VARIANT_ID = parseInt(root.dataset.variantId);
  const isSv = root.dataset.locale === 'sv';
  const isEs = root.dataset.locale === 'es';
  const route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  const escapeHtml = value => String(value || '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  let busy = false;
  let servicePriceText = '';

  async function getCart() {
    const r = await fetch(route + 'cart.js');
    if (!r.ok) throw new Error('Cart unavailable');
    return r.json();
  }

  function fmtMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    let value;
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return '+' + format.replace(placeholderRegex, value);
  }

  async function getServicePriceText() {
    if (servicePriceText) return servicePriceText;
    try {
      const r = await fetch(route + 'products/framing-service.js');
      if (!r.ok) throw new Error('Framing service unavailable');
      const p = await r.json();
      const variant = p.variants.find(v => v.id === VARIANT_ID) || p.variants[0];
      servicePriceText = fmtMoney(variant.price);
    } catch (e) {
      servicePriceText = '';
    }
    return servicePriceText;
  }

  function refreshCartUI() {
    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getCart === 'function') {
      cartItems.getCart();
    }
  }

  async function render() {
    let cart;
    try { cart = await getCart(); } catch (e) { return; }

    const items = cart.items;

    // Only offer mounting for a print and frame of the same size.
    // Legacy _pair links and cart-added _print_key links take precedence.
    const matching = window.DcCartPairing.match(cart, new Set(), VARIANT_ID);
    const allPairs = matching.pairs;
    const validServices = new Set(allPairs.map(pair => pair.service && pair.service.key).filter(Boolean));
    const orphanedServices = matching.services.filter(item => !validServices.has(item.key));
    const excessServices = matching.services.filter(item => item.quantity > (matching.serviceCounts.get(item.key) || 0));
    if (orphanedServices.length || excessServices.length) {
      for (const item of excessServices) {
        const response = await fetch(route + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: matching.serviceCounts.get(item.key) || 0 })
        });
        if (!response.ok) throw new Error('Could not remove obsolete mounting service');
      }
      refreshCartUI();
      return;
    }

    if (allPairs.length === 0) {
      root.style.display = 'none';
      root.innerHTML = '';
      return;
    }

    root.style.display = '';

    const priceText = await getServicePriceText();
    if (!priceText) { root.style.display = 'none'; return; }

    root.innerHTML = `
      <div class="cfs-group" id="cfs-group">
        <p class="cfs-intro">${isSv ? 'Print och ram i samma storlek. Vi monterar konstverket åt dig, redo att hängas upp.' : isEs ? 'Lámina y marco del mismo tamaño. Lo montamos para que llegue listo para colgar.' : 'Print and frame are the same size. We mount it for you, ready to hang.'}</p>
        ${allPairs.map(({ print, frame, service }, index) => {
          const checked = !!service;
          const printTitle = (print.product_title || '').split('–')[0].trim();
          const frameTitle = (frame.product_title || '').replace(' Frame', '').replace(' Wooden', '').trim();
          const frameLabel = isSv ? ({ 'Oak': 'Ek', 'Dark Oak': 'Mörk ek', 'Black': 'Svart', 'White': 'Vit' }[frameTitle] || frameTitle) : isEs ? ({ 'Oak': 'Roble', 'Dark Oak': 'Roble oscuro', 'Black': 'Negro', 'White': 'Blanco' }[frameTitle] || frameTitle) : frameTitle;
          return `
            <label class="cfs-item${checked ? ' cfs-item--active' : ''}" data-pair-index="${index}">
              <span class="cfs-check">
                <input type="checkbox" ${checked ? 'checked' : ''}
                  data-pair-index="${index}">
                <span class="cfs-box">
                  <svg class="cfs-tick" viewBox="0 0 10 8" fill="none">
                    <path d="M1 4L3.5 6.5L9 1" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </span>
              <span class="cfs-content">
                <span class="cfs-title">${isSv ? 'Få ditt konstverk inramat' : isEs ? 'Recíbelo enmarcado' : 'Have it framed for you'}</span>
                <span class="cfs-desc">${escapeHtml(printTitle)} · ${escapeHtml(frameLabel)} · ${escapeHtml(print.variant_title || '')}</span>
              </span>
              <span class="cfs-price">${priceText}</span>
            </label>
          `;
        }).join('')}
      </div>`;

    // Bind checkboxes
    root.querySelectorAll('input[type=checkbox]').forEach(cb => {
      cb.addEventListener('change', async function () {
        if (busy) return;
        busy = true;
        const group = root.querySelector('#cfs-group');
        if (group) group.classList.add('is-loading');

        const pair = allPairs[Number(this.dataset.pairIndex)];
        const frameKey = pair.frame.key;
        const printKey = pair.print.key;
        const label     = this.closest('.cfs-item');

        try {
          if (this.checked) {
            const props = { '_frame_key': frameKey, '_print_key': printKey };
            const response = await fetch(route + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: VARIANT_ID, quantity: 1, properties: props })
            });
            if (!response.ok) throw new Error('Could not add mounting service');
            if (label) label.classList.add('cfs-item--active');
          } else {
            const serviceItem = pair.service;
            if (serviceItem) {
              const response = await fetch(route + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: serviceItem.key, quantity: Math.max(0, serviceItem.quantity - 1) })
              });
              if (!response.ok) throw new Error('Could not remove mounting service');
            }
            if (label) label.classList.remove('cfs-item--active');
          }
          refreshCartUI();
          scheduleRender(400);
        } catch (err) {
          console.error('[cfs]', err);
          this.checked = !this.checked;
          if (label) label.classList.toggle('cfs-item--active');
        } finally {
          busy = false;
          if (group) group.classList.remove('is-loading');
        }
      });
    });
  }

  // Debounced render — collapses rapid-fire events into a single call
  let _timer = null;
  function scheduleRender(ms) {
    clearTimeout(_timer);
    _timer = setTimeout(render, ms);
  }

  // Lazy init: don't fetch /cart.js until the drawer is actually open
  let _ready = !!document.querySelector('[data-cart-page]');
  if (_ready) scheduleRender(50);
  document.addEventListener('theme:cart-drawer:open', () => {
    _ready = true;
    scheduleRender(50);
  });
  document.addEventListener('theme:product:added', () => {
    _ready = true; // drawer auto-opens when product is added
    scheduleRender(400);
  });
  document.addEventListener('theme:cart:add', () => {
    if (_ready) scheduleRender(400);
  });
  document.addEventListener('theme:cart:change', () => {
    if (_ready) scheduleRender(300);
  });
})();
